<template>
  <div>
    <iframe
      class="iframe--document-embed"
      :height="height"
      :width="width"
      frameborder="0"
      :title="title"
      @load="loadIframe"
      @error="reloadIframe"
      ref="iframeEl"
    />
  </div>
</template>

<script>
export default {
  name: "DocumentEmbed",
  props: ["url", "title", "height", "width"],
  data() {
    return {
      trys: 5,
      reloadSeconds: 3,
      loaded: false,
    };
  },
  computed: {
    getIframeSrc() {
      return `https://docs.google.com/gview?url=${this.url}&embedded=true`;
    },
  },
  methods: {
    loadIframe() {
      this.loaded = !this.loaded && true;
      clearInterval(this.iframeTimeoutId);
    },
    reloadIframe() {
      if (this.trys > 0) {
        console.log('reload');
        this.$refs.iframeEl.src = this.getIframeSrc;
        this.trys--;
        return;
      }
      clearInterval(this.iframeTimeoutId);
    },
  },
  mounted() {
    this.$refs.iframeEl.src = this.getIframeSrc;
    this.iframeTimeoutId = setInterval(
      this.reloadIframe,
      1000 * this.reloadSeconds
    );
  },
};
</script>
